/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown>, count: NonNullable<unknown> }} Wrapped_Muscles_One_ShortInputs */

const en_us2_wrapped_muscles_one_short = /** @type {(inputs: Wrapped_Muscles_One_ShortInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.names} is one set away.`);
	return /** @type {LocalizedString} */ (`${i?.names} are one set away.`)
	
};

const pt_br2_wrapped_muscles_one_short = /** @type {(inputs: Wrapped_Muscles_One_ShortInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.names} está a 1 série.`);
	return /** @type {LocalizedString} */ (`${i?.names} estão a 1 série.`)
	
};

const es_419_wrapped_muscles_one_short = /** @type {(inputs: Wrapped_Muscles_One_ShortInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.names} está a una serie de la meta.`);
	return /** @type {LocalizedString} */ (`${i?.names} están a una serie de la meta.`)
	
};

const pt_pt2_wrapped_muscles_one_short = /** @type {(inputs: Wrapped_Muscles_One_ShortInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.names} está a 1 série.`);
	return /** @type {LocalizedString} */ (`${i?.names} estão a 1 série.`)
	
};

const fr_fr2_wrapped_muscles_one_short = /** @type {(inputs: Wrapped_Muscles_One_ShortInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.names} : plus qu'une série.`);
	return /** @type {LocalizedString} */ (`${i?.names} : plus qu'une série chacun.`)
	
};

const de_de2_wrapped_muscles_one_short = /** @type {(inputs: Wrapped_Muscles_One_ShortInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.names}: noch ein Satz bis zum Ziel.`);
	return /** @type {LocalizedString} */ (`${i?.names}: je noch ein Satz bis zum Ziel.`)
	
};

const it_it2_wrapped_muscles_one_short = /** @type {(inputs: Wrapped_Muscles_One_ShortInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`A ${i?.names} manca una serie.`);
	return /** @type {LocalizedString} */ (`A ${i?.names} manca una serie.`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "{names} is one set away." |
* | * | "{names} are one set away." |
*
* @param {Wrapped_Muscles_One_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_muscles_one_short = /** @type {((inputs: Wrapped_Muscles_One_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Muscles_One_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_muscles_one_short(inputs)
	if (locale === "es-419") return es_419_wrapped_muscles_one_short(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_muscles_one_short(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_muscles_one_short(inputs)
	if (locale === "de-DE") return de_de2_wrapped_muscles_one_short(inputs)
	if (locale === "it-IT") return it_it2_wrapped_muscles_one_short(inputs)
	return en_us2_wrapped_muscles_one_short(inputs)
});
export { wrapped_muscles_one_short as "wrapped.muscles_one_short" }